import {Component, React, observer, resolveCss} from '$src/handy'
import * as css from './GenericButton.css'

interface Props {
  variant:
    | 'bold'
    | 'smallbold'
    | 'pale'
    | 'smallPale'
    | 'link'
    | 'round'
    | 'roundActive'
    | 'smallRound'
    | 'icon'
  css?: any
  withMargin?: boolean
  disabled?: boolean
  [rest: string]: any
}

@observer
export default class GenericButton extends Component<Props, {}> {
  render() {
    const {props} = this
    const {
      css: propsCss,
      children,
      variant,
      withMargin,
      disabled,
      ...propsRest
    } = props
    const classes = resolveCss(css, propsCss)

    return (
      <button
        {...classes(
          'container',
          variant,
          withMargin === true && 'withMargin',
          disabled && 'disabled',
        )}
        {...propsRest}
      >
        {children}
      </button>
    )
  }
}



// WEBPACK FOOTER //
// ./src/common/GenericButton.tsx